import React, { useContext, useState, useEffect } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { renderFormField } from 'utils/forms'
import { selectData } from 'layouts/onboarding'
import ValuePoint from 'admin/components/ValuePoint'
import { Card, Grid, Typography, Box, Button, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const dollarCentsFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function TSPContributions({
  collapseSections,
  toggleCollapse,
  tspMaxContributionAmount,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const [localForm, setLocalForm] = useState({
    tspBalance: intakeState.tspBalance || '',
    tspContribution: intakeState.tspContribution || '',
    tspContributionAmount: intakeState.tspContributionAmount || '',
    tspRothBalance: intakeState.tspRothBalance || '',
    tspRothContribution: intakeState.tspRothContribution || '',
    tspRothContributionAmount: intakeState.tspRothContributionAmount || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const showTSPLoans = intakeState?.tspLoans
  const showRothTSP = intakeState?.tspRoth
  const showTSPContribution = intakeState?.tsp

  const [percentDollarsQuestion, setPercentDollarsQuestion] = useState(true)
  const [percentDollarsQuestionRoth, setPercentDollarsQuestionRoth] =
    useState(true)

  const dollarsToPercent = (contributionAmount) => {
    return intakeState?.baseSalary
      ? (((contributionAmount / 80) * 2087) / intakeState?.baseSalary) * 100
      : 0
  }
  const percentToDollars = (contributionPercent) => {
    return intakeState?.baseSalary
      ? (intakeState?.baseSalary / 2087) * 80 * (contributionPercent / 100)
      : 0
  }

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.tspContributions}
                style={{ width: '100%' }}
              >
                {intakeState?.retirementSystem === 'csrs' ? (
                  <ValuePoint
                    text="No TSP Match for CSRS Clients"
                    type="warning"
                  />
                ) : (
                  <>
                    {(intakeState?.tspContribution || 0) +
                      (intakeState?.tspRothContribution || 0) <
                      5 && (
                      <ValuePoint
                        text="Contribution Less than 5%"
                        type="warning"
                      />
                    )}
                    <ValuePoint
                      text={`Max TSP Contribution Match Per Pay Period: ${dollarFormat.format(
                        (intakeState?.baseSalary / 2087) * 80 * 0.05
                      )}`}
                      type="donut"
                    />
                    {(intakeState?.tspContribution || 0) +
                      (intakeState?.tspRothContribution || 0) >=
                      5 && (
                      <ValuePoint
                        text="Meeting Max Match Contribution"
                        type="success"
                      />
                    )}
                  </>
                )}
                <ValuePoint
                  text={`Maximum TSP Contribution for the year: ${dollarFormat.format(
                    tspMaxContributionAmount
                  )}`}
                  type="data"
                />
                <ValuePoint
                  text={`General Contribution to Meet Max: ${
                    intakeState?.baseSalary
                      ? (
                          (tspMaxContributionAmount / intakeState.baseSalary) *
                          100
                        ).toFixed(2)
                      : 'Need Base Salary for '
                  }%`}
                  type="data"
                />
                {(intakeState?.tspContribution || 0) +
                  (intakeState?.tspRothContribution || 0) >
                  (tspMaxContributionAmount / intakeState?.baseSalary) *
                    100 && (
                  <>
                    <ValuePoint
                      text="Potentially Contributing more than the Max"
                      type="warning"
                    />
                  </>
                )}
                {intakeState?.tspLoans && (
                  <ValuePoint text="Strategy - Discuss TSP Loan Options" />
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="tsp"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('tspContributions')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                TSP Contributions
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.tspContributions
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse
            in={collapseSections.tspContributions}
            style={{ width: '100%' }}
          >
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} mt={2}>
                <Typography variant="h5">Traditional TSP Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'tsp',
                  label: 'Do you contribute to the Traditional TSP?',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.tsp,
                  onChange: updateIntakeStateAndSubmit((tsp) =>
                    updateIntakeStateAtKey({ tsp })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'tspBalance',
                  label: 'Current Traditional TSP balance',
                  placeholder: '$250,000.00',
                  inputType: 'currencyFloat',
                  value: localForm.tspBalance,
                  onChange: (e) => handleChange('tspBalance')(e),
                  onBlur: updateIntakeStateAndSubmit((tspBalance) =>
                    updateIntakeStateAtKey({ tspBalance })
                  ),
                })}
              </Grid>
              {showTSPContribution && (
                <>
                  {percentDollarsQuestion ? (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'tspContribution',
                          label: 'What percentage do you contribute?',
                          placeholder: 'Ex. 5.0%',
                          inputType: 'percentage',
                          value: localForm.tspContribution,
                          onChange: (e) => {
                            handleChange('tspContribution')(e)
                            handleChange('tspContributionAmount')(
                              percentToDollars(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (tspContribution) =>
                              updateIntakeStateAtKey({
                                tspContribution,
                                tspContributionAmount:
                                  percentToDollars(tspContribution),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestion(false)}
                        >
                          Use amount contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'tspContributionAmount',
                          label:
                            'What amount do you contribute per pay period?',
                          placeholder: '$135.00',
                          inputType: 'currencyFloat',
                          value: localForm.tspContributionAmount,
                          onChange: (e) => {
                            handleChange('tspContributionAmount')(e)
                            handleChange('tspContribution')(dollarsToPercent(e))
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (tspContributionAmount) =>
                              updateIntakeStateAtKey({
                                tspContributionAmount,
                                tspContribution: dollarsToPercent(
                                  tspContributionAmount
                                ),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestion(true)}
                        >
                          Use percentage contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </>
              )}

              {/* ROTH TSP */}
              <Grid item xs={12} mt={2}>
                <Typography variant="h5">Roth TSP Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'tspRoth',
                  label: 'Do you contribute to the Roth TSP?',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.tspRoth,
                  onChange: updateIntakeStateAndSubmit((tspRoth) =>
                    updateIntakeStateAtKey({ tspRoth })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'tspRothBalance',
                  label: 'Current Roth TSP balance',
                  placeholder: '$250,000.00',
                  inputType: 'currencyFloat',
                  value: localForm.tspRothBalance,
                  onChange: (e) => handleChange('tspRothBalance')(e),
                  onBlur: updateIntakeStateAndSubmit((tspRothBalance) =>
                    updateIntakeStateAtKey({ tspRothBalance })
                  ),
                })}
              </Grid>

              {showRothTSP && (
                <>
                  {percentDollarsQuestionRoth ? (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'tspRothContribution',
                          label: 'What percentage do you contribute?',
                          placeholder: 'Ex. 5.0%',
                          inputType: 'percentage',
                          value: localForm.tspRothContribution,
                          onChange: (e) => {
                            handleChange('tspRothContribution')(e)
                            handleChange('tspRothContributionAmount')(
                              percentToDollars(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (tspRothContribution) =>
                              updateIntakeStateAtKey({
                                tspRothContribution,
                                tspRothContributionAmount:
                                  percentToDollars(tspRothContribution),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestionRoth(false)}
                        >
                          Use amount contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'tspRothContributionAmount',
                          label:
                            'What amount do you contribute per pay period?',
                          placeholder: '$135.00',
                          inputType: 'currencyFloat',
                          value: localForm.tspRothContributionAmount,
                          onChange: (e) => {
                            handleChange('tspRothContributionAmount')(e)
                            handleChange('tspRothContribution')(
                              dollarsToPercent(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (tspRothContributionAmount) =>
                              updateIntakeStateAtKey({
                                tspRothContributionAmount,
                                tspRothContribution: dollarsToPercent(
                                  tspRothContributionAmount
                                ),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestionRoth(true)}
                        >
                          Use percentage contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </>
              )}
              <Grid item xs={12} mt={2}>
                <Typography variant="h5">TSP Loan Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {renderMuiFormField({
                      autoFocus: false,
                      id: 'tspLoans',
                      label: 'Do you have any TSP loans?',
                      placeholder: '',
                      inputType: 'select',
                      value: intakeState.tspLoans,
                      onChange: updateIntakeStateAndSubmit((tspLoans) =>
                        updateIntakeStateAtKey({ tspLoans })
                      ),
                      options: selectData.yesNo,
                    })}
                  </Grid>
                  {showTSPLoans && (
                    <Grid item xs={12}>
                      {renderMuiFormField({
                        inputType: 'tspLoanReview',
                      })}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default TSPContributions
